(function () {
  'use strict';

  // Click-to-play/pause for the "Product Details & Instructions" showcase
  // video (collapsible-content section). The video ships with no native
  // controls; this wires the floating play button — and the video itself —
  // up to toggle playback, fading the button while playing.
  document.querySelectorAll('.ck-showcase-video').forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var button = wrap.querySelector('.ck-showcase-video__play');
    if (!video || !button) return;

    var togglePlayback = function () {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    };

    var syncState = function () {
      wrap.classList.toggle('is-playing', !video.paused && !video.ended);
    };

    button.addEventListener('click', togglePlayback);
    video.addEventListener('click', togglePlayback);
    video.addEventListener('play', syncState);
    video.addEventListener('pause', syncState);
    video.addEventListener('ended', syncState);
  });
})();
